import _camelize from './internal/_camelize'

const toCamel = str => _camelize(str, 'lower')
export default toCamel
